import React from "react";
import GridImg from "components/comp/GridImg";
import Ped from "assets/images/sPedestal_외형편집.png"

const SpdstDesc = () => {
  return (
      <div className="intro">
          <div className="Product intro">
            <div className="Product-content">
              <h3>에스페데스탈(sPedestal)</h3>
              <div className="paragraph">
                <ul>
                  <li>페데스탈 제조사(TallyKey/m-Tech/Rolec/Marine Planet 등)와 상관 없이 전기/수도/조명의 원격 제어가 가능 하도록 하는 한국 최초의 페데스탈 원격 제어시스템</li>
                  <li>인증된 무선 통신방식의 사용으로 안정성 확보</li>
                  <li>선석관리, 마리나 관리시스템과의 호환 및 커스터마이징</li>
                  <li>완벽한 한글 지원(SMS)</li>
                  <li>RFID 카드 또는 모바일장치를 통한 제어</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="introSub">
            <GridImg img={Ped} width="80%" height="330px"/>
          </div>
      </div>
  );
};

export default SpdstDesc;
